import './howwork.css'
import howWorksShape1 from '../../assets/images/how-works-shape-1.png'
import howWorksShape2 from '../../assets/images/how-works-shape-2.png'
import howWorksShape3 from '../../assets/images/how-works-shape-3.png'

const HowWork = () => {
    return (
        <div className="how-works-area pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <span className="top-title top-title-three"><i className="flaticon-flash"></i>HOW WE WORK</span>
                    <h2>Our Working Process</h2>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-6 col-sm-4" data-show="true" >
                        <div className="how-work-content">
                            <div className="works-icon">
                                <i className="flaticon-guru"></i>
                            </div>
                            <h3><b>01.</b>Consult Our Expert</h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-sm-4" data-show="true" >
                        <div className="how-work-content">
                            <div className="works-icon">
                                <i className="flaticon-planning"></i>
                            </div>
                            <h3><b>02.</b>Choose Your Plan</h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-sm-4" data-show="true" >
                        <div className="how-work-content">
                            <div className="works-icon">
                                <i className="flaticon-click"></i>
                            </div>
                            <h3><b>03.</b>Finalise Your Plan</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="how-work-shape-1">
                <img src={howWorksShape2} alt="images" />
            </div>
            <div className="how-work-shape-2">
                <img src={howWorksShape3} alt="images" />
            </div>
            <div className="how-work-shape-3">
                <img src={howWorksShape1} alt="images" />
            </div>
        </div>
    )
}

export default HowWork